module.exports = __webpack_public_path__ + "img/about3.5cd69e7c.webp";